import axios from 'axios';
import { RegistrationModel } from 'models/authentication';
import UserResource from './resource';

export const List = (signal?: AbortSignal) => axios.get<UserResource[]>('/api/Accounts', { signal });

export const Find = (id: string, signal?: AbortSignal) => axios.get<UserResource>(`/api/Accounts/${id}`, { signal });

export const Register = (model: RegistrationModel, signal?: AbortSignal) => axios.post<UserResource>('/api/Accounts', model, { signal });

export const Delete = (id: string, signal?: AbortSignal) => axios.delete(`/api/Accounts/${id}`, { signal });
